import { z } from 'zod';
import { avatarUrlSchema, nameSchema } from '@/utils/schemas';

export const userInfoByCodeScheme = z.object({
  UID: z.number(),
  NickName: nameSchema,
  HeadImg: avatarUrlSchema,
  Gender: z.union([z.literal(0), z.literal(1), z.literal(2)]),
  Sign: nameSchema,
});

export type UserInfoByCode = z.infer<typeof userInfoByCodeScheme>;

export const otherUserInfoScheme = userInfoByCodeScheme.extend({
  IsFriend: z.boolean().nullish(),
});

export type OtherUserInfo = z.infer<typeof otherUserInfoScheme>;
